module.exports = __webpack_public_path__ + "static/media/reader_disket2.6121f75c.ico";